/**
 * Contains all the data points related Premium Dashboard
 */
export default {
    PremiumDashManageSecurity: {
        datapoint: {
            name: 'PremiumDashManageSecurityClicked',
        },
    },
};
//# sourceMappingURL=datapoints.js.map